module.exports = __webpack_public_path__ + "img/2-2.4972b7e0.jpg";